module.exports = __webpack_public_path__ + "static/media/sprite_prev.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/images/default/sprite_prev.png
// module id = ./src/CSS/assets-minified/images/default/sprite_prev.png
// module chunks = 0